import React from 'react';
import { Card, CardContent, Typography, Grid, Box, Chip, Button } from '@mui/material';
import { COLOR_PRIMARY_1 } from 'src/utils/colors';

interface CustomBasicCardProps {
  title: string;
  icon: React.ReactNode;
  content: React.ReactNode;
  actionText?: string;
  onActionClick?: () => void;
  headerChip?: string;
}

const CustomBasicCard: React.FC<CustomBasicCardProps> = ({
  title,
  icon,
  content,
  actionText,
  onActionClick,
  headerChip,
}) => {
  return (
    <Card sx={{ borderRadius: 2, boxShadow: 2, height: '100%', p: 1 }}>
      <CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', mb: 4 }}>
          <Box sx={{ mr: 1, display: 'flex', alignItems: 'center', color: COLOR_PRIMARY_1 }}>
            {icon}
          </Box>
          <Typography
            variant="h6"
            sx={{ display: 'flex', alignItems: 'center', fontWeight: 500, fontSize: '16px' }}
          >
            {title}
          </Typography>
          {headerChip && (
            <Chip
              label={headerChip}
              size="small"
              sx={{
                ml: 'auto',
                backgroundColor: 'grey.100',
                color: 'text.secondary',
                fontSize: '0.75rem',
              }}
            />
          )}
        </Box>

        <Grid container spacing={3} sx={{ flex: 1, mb: 4 }}>
          {content}
        </Grid>

        {actionText && onActionClick && (
          <Box sx={{ textAlign: 'right' }}>
            <Button
              onClick={onActionClick}
              sx={{
                color: COLOR_PRIMARY_1,
                textTransform: 'none',
                fontWeight: 500,
                '&:hover': {
                  backgroundColor: 'transparent',
                },
              }}
            >
              {actionText}
            </Button>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default CustomBasicCard;
